import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import parallax1 from '../../images/parallax1.png';
import parallax2 from '../../images/parallax2.png';
import parallax3 from '../../images/parallax3.png';
import './TheProblem.css';

function Vegetables() {
    return (
        <section id='problem'>
            <div className="parallax-bg">
                <Container fluid>
                    <Row className='col-op-first'>
                        <Col lg={6}>
                            <div className='col-prob-first-div'>
                                <h1>
                                    The Problem
                                </h1>
                            </div>
                        </Col>
                        <Col lg={6}>

                        </Col>
                    </Row>
                </Container>

                <Container fluid>
                    <Row className='col-op'>
                        <Col lg={4}>
                            <div className='veg-left-div'>
                                <img src={parallax1} alt="" />
                            </div>
                        </Col>
                        <Col lg={8}>
                            <div className='veg-right-txt'>
                                <div>
                                    <h3>
                                        Almost half of all the fruits & vegetables<br />
                                        produced are wasted
                                    </h3>

                                    <br />
                                    <h3>
                                        $300BN wasted in industrial countries of which<br />
                                        $100BN is fresh produce
                                    </h3>
                                    <br />
                                    <h3>
                                        10% of fresh produce is lost along the supply chain
                                    </h3>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>

                <Container fluid>
                    <Row className='col-op'>
                        <Col lg={4} >
                            <div className='veg-left-div'>
                                <img src={parallax2} alt="" />
                            </div>
                        </Col>
                        <Col lg={8}>
                            <div className='veg-right-txt'>
                                <div>
                                    <h3>
                                        Wrong decisions due to inaccurate information <br />
                                        account for an additional 5% of lost food value
                                    </h3>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>

                <Container fluid>
                    <Row className='col-op'>
                        <Col lg={4}>
                            <div className='veg-left-div'>
                                <img src={parallax3} alt="" />
                            </div>
                        </Col>
                        <Col lg={8}>
                            <div className='veg-right-txt'>
                                <div>
                                    <h3>
                                        Huge negative impact on the environment & society
                                    </h3>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </section>
    )
}

export default Vegetables
